import React from "react";
import MaterialTable, {MTableToolbar} from "material-table";
import tableicons from "../tableicons";
import {ajustesResources} from "../endpoints";
import SnackbarAlert from "./SnackbarAlert";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import DialogEliminar from "./DialogEliminar";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import useToken from "../useToken";

class TablaModificacionesParaAprobar extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            tipo: this.props.tipo,
            selectedRow:null,
            modificaciones:[],
            openSnack:false,
            severity: null,
            message:null,
            aprobar: false,
            rechazar:false,
            id_conteo: null,
            title: "",
            content: "",
            aprobar_todo:false,
            user: useToken.getUser(),
        }
    }

    obtenerAjustes = () =>{
        ajustesResources.getAllAjustes(this.state.tipo).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(data => {
            if(data.status_code === 200){
                this.setState({ modificaciones:data.ajustes})
            }
            else if (data.status_code === 401){
                this.setState({openSnack:true,cargando:false, severity:data.severity, message:data.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
        });
    }

    aprobarModificacion = (rowData)=>{
        if (this.state.tipo ==='cliente') {
            this.setState({aprobar: true, id_conteo:rowData.id, title: "Aprobar modificación",content: "Está seguro que desea aprobar la modificación?", openSnack:false})
        }
        else{
            this.setState({aprobar: true, id_conteo:rowData.id_conteo, title: "Aprobar modificación",content: "Está seguro que desea aprobar la modificación?", openSnack:false})
        }
    }

    aprobar_todo = ()=>{
        this.setState({aprobar_todo: true, title: "Aprobar todas las modificaciones",content: "Está seguro que desea aprobar todas las modificaciones?", openSnack:false})
    }

    rechazarModificacion = (rowData)=>{
        if (this.state.tipo ==='cliente') {
            this.setState({rechazar: true, id_conteo:rowData.id, title: "Rechazar modificación",content: "Está seguro que desea rechazar la modificación?", openSnack:false})
        }
        else{
            this.setState({rechazar: true, id_conteo:rowData.id_conteo, title: "Rechazar modificación",content: "Está seguro que desea rechazar la modificación?", openSnack:false})
        }
    }

    componentDidMount() {
        this.obtenerAjustes()
    }

    refrescarDatos =(estado,severity) =>{
        this.setState({openSnack:false, severity: null, message:null,selectedRow: null, aprobar:false, rechazar:false, aprobar_todo:false});
        if(severity === "success"){
            this.obtenerAjustes()
        }
        this.setState({openSnack:true, severity:severity, message:estado})
    }

    handleClose = () => {
        this.setState({aprobar: false, rechazar:false, selectedRow: null, aprobar_todo:false});
    };

    render() {
        return (
            <div>
                <MaterialTable
                    components={{
                        Toolbar: props => (
                            <div>
                                <MTableToolbar {...props} />
                                {this.state.user.perfil.includes('operador') &&
                                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                                        <Grid item>
                                            <Button startIcon={
                                                <CheckIcon/>} variant="contained" color="primary" onClick={()=>{this.aprobar_todo()}}>
                                                Aprobar todas</Button>
                                        </Grid>
                                    </Grid>}
                            </div>
                        ),
                    }}
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    options={{
                        pageSize: 10,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title=""
                    data={this.state.modificaciones}
                    columns={[
                        { title: 'Reg.Conteo', field: 'id_conteo',editable:"never"},
                        { title: 'Tag', field: 'tag',editable:"never"},
                        { title: 'Artículo', field: 'articulo',editable:"never"},
                        { title: 'Cód.escan.', field: 'codigo',editable:"never"},
                        { title: 'Descripción.', field: 'descripcion',editable:"never",
                            hidden: (this.state.user.app !== 'walmart' && this.state.user.app !== 'walmart_parciales'),},
                        { title: 'Cantidad Inicial', field: 'inicial',editable:"never"},
                        { title: 'Ajuste', field: 'ajuste',editable:"never"},
                        { title: 'Cantidad Final', field: 'final',editable:"never"},
                        { title: 'Val.ajuste', render:rowData => new Intl.NumberFormat("de-DE").format(rowData.importe),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.importe).indexOf(term) !== -1),
                            editable:"never", },
                        { title: 'Motivo', field: 'motivo' ,editable:"never"},
                        { title: 'Usuario',
                            render:rowData => rowData.nombre1 + " " +rowData.apellido1,
                            customFilterAndSearch: ((term, rowData) => (rowData.nombre1 + " " +rowData.apellido1).indexOf(term) !== -1),
                            editable:"never"},
                        { title: 'Fecha y hora', field: 'timestamp',
                            render: rowData => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString(),
                            customFilterAndSearch: ((term,rowData) => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString().indexOf(term) !== -1),
                            editable:"never"},
                        { title: 'Aprobado SCA', field: 'aprobado',
                            render: rowData => (rowData.aprobado ? <CheckIcon/> : (rowData.aprobado === false ? <ClearIcon/> : null) ),editable:"never"},
                        { title: 'Aprobado Cliente', field: 'aprobado_cliente',
                            hidden: (this.state.user.app !== 'walmart' && this.state.user.app !== 'walmart_parciales'),
                            render: rowData => (rowData.aprobado_cliente ? <CheckIcon/> : (rowData.aprobado_cliente === false ? <ClearIcon/> : null) ),editable:"never"},
                    ]}
                    actions={[
                        rowData => ({
                            icon:  () => <CheckIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Aprobar modificación',
                            onClick: (event, rowData) => this.aprobarModificacion(rowData),
                            disabled: (rowData.aprobado === true),
                            hidden: this.state.user.perfil.includes('analista')
                        }),

                        rowData => ({
                            icon:  () => <ClearIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Rechazar modificación',
                            onClick: (event, rowData) => this.rechazarModificacion(rowData),
                            disabled: rowData.aprobado === false,
                            hidden: this.state.user.perfil.includes('analista')
                        }),
                        rowData => ({
                            icon:  () => <CheckIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Aprobar modificación',
                            onClick: (event, rowData) => this.aprobarModificacion(rowData),
                            disabled: rowData.aprobado_cliente === true,
                            hidden: this.state.user.perfil.includes('operador') || this.state.tipo === 'sca' || this.state.user.perfil.includes('SCA') || this.state.user.perfil.includes('admin') 
                        }),

                        rowData => ({
                            icon:  () => <ClearIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Rechazar modificación',
                            onClick: (event, rowData) => this.rechazarModificacion(rowData),
                            disabled: rowData.aprobado_cliente === false,
                            hidden: this.state.user.perfil.includes('operador') || this.state.tipo === 'sca' || this.state.user.perfil.includes('SCA') || this.state.user.perfil.includes('admin') 
                        }),
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.aprobar? <DialogEliminar origen={"AjustesAprobar"} handleClose={this.handleClose} refrescar={this.refrescarDatos} content={this.state.content} title={this.state.title} id={this.state.id_conteo} tipo={this.state.tipo} />:null}
                {this.state.rechazar? <DialogEliminar origen={"AjustesRechazar"} handleClose={this.handleClose} refrescar={this.refrescarDatos} content={this.state.content} title={this.state.title} id={this.state.id_conteo}  tipo={this.state.tipo}/>:null}
                {this.state.aprobar_todo? <DialogEliminar origen={"AprobarTodo"} handleClose={this.handleClose} refrescar={this.refrescarDatos} content={this.state.content} title={this.state.title} id={null}  tipo={this.state.tipo} />:null}
            </div>
        )
    }

}
export default TablaModificacionesParaAprobar;